import React from 'react';
import { Tooltip } from 'antd';
import privateIcon from '../../assets/lock.svg';
import publicIcon from '../../assets/world.svg';
import { MindMapContext } from '../../Context/contex';
import './PrivacyIcon.css';

const PRIVATE_ID = 2;

const PrivacyIcon = () => {
    const { documentInfo } = MindMapContext();
    const isPrivate = documentInfo?.privacyId === PRIVATE_ID;
    const label = isPrivate ? 'Private document' : 'Public document';

    return (
        <Tooltip title={label}>
            <img
                src={isPrivate ? privateIcon : publicIcon}
                alt={label}
                className={`privacy-icon ${isPrivate ? 'privacy-icon--private' : 'privacy-icon--public'}`}
            />
        </Tooltip>
    );
};

export default PrivacyIcon;
